import { QueryClient } from '@tanstack/react-query';
import { AppError } from '@/core/errors/AppError';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (count, err) => {
                if (err instanceof AppError && [401, 403, 404].includes(err.status ?? 0))
                    return false;
                return count < 2;
            },
            staleTime: 30_000,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: false,
        },
    },
});
